import { PAYERNONPOPULATION } from "../../api/urls";
import { FETCH_PAYERNONPOPULATION_SUCCESS, FETCH_PAYERNONPOPULATION_FAIL, FETCH_PAYERNONPOPULATION_INPUT_DATA } from "./actionTypes";

export const changeInputData = (column = null, search = null) => {
  return dispatch => {
    const obj = {
      type: FETCH_PAYERNONPOPULATION_INPUT_DATA,
      data: {},
    }
    if (column) {
      obj.data[column] = search;
    }
    dispatch(obj);
  }
}

const payerNonPopulationData = (url = null, page = 1) => {
  return dispatch => {
    const URL = (url) ? url : PAYERNONPOPULATION + `&page=${page}`;
    fetch(URL, {
      method: "GET",
      headers: {
        'Authorization': 'Token ' + localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }
    })
      .then(resp => resp.json())
      .then(data => {
        dispatch({
          type: FETCH_PAYERNONPOPULATION_SUCCESS,
          data: { ...data, page: page },
        });
      })
      .catch(err => {
        dispatch({
          type: FETCH_PAYERNONPOPULATION_FAIL,
          data: {
            error: err,
          }
        });
      });
  }
}

export const payerNonPopulationDataExcel = (url, page = 1) => {
  return dispatch => {
    const URL = (url) ? url + '&export=true' : PAYERNONPOPULATION + `&page=${page}&export=true`;
    // window.open(URL, "_blank");
    fetch(URL, {
      method: "GET",
      headers: {
        'Authorization': 'Token ' + localStorage.getItem('token'),
        // 'Content-Type': 'application/json',
      }
    })
      .then(response => response.blob())
      .then(blob => {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = `Hesabat_YVOK_${new Date().toJSON().slice(0, 10)}.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      })
      .catch(err => {
        return dispatch({
          type: FETCH_PAYERNONPOPULATION_FAIL,
          data: {
            error: err,
          }
        });
      });
  }
}

export default payerNonPopulationData;
